import { useSession } from "next-auth/react";
import { CustomerLayout, LawyerLayout, AdminLayout } from "components/layout";

const RoleBasedLayout = ({ children }) => {
  const { data: session } = useSession();
  if (session?.user?.role === "lawyer") {
    return <LawyerLayout>{children}</LawyerLayout>;
  }

  if (session?.user?.role === "admin") {
    return <AdminLayout>{children}</AdminLayout>;
  }

  return <CustomerLayout>{children}</CustomerLayout>;
};

export default RoleBasedLayout;
